/**
 * Created by Jasmine on 2018/8/15.
 */

import {observable} from "mobx";
import {request, apis} from '../../../utils/net';

const store = observable({
    manchineList: [],
    manchineListPage: 1,
    manchineListTotal: 0,
    invoiceTypes: [], //可开发票类型
    defaultCheckedInvoices:[],      //选中开票发票类型
    tax_disk_type: 1,   //是否是航信盘
    machineList: null, //获取航信分机号列
    bwTaxNumList: null,  //获取百望税盘列表
    taxDiscList: null,  //税盘号
    taxId : null, // 税盘idM,
    reviewer: '', // 复核人
    payee: '', // 收款人
    taxNumHX: '', // 航信税盘号
    submitData:null, //保存信息
    has_synced: false, //插件端是否同步过税盘 bool

     // 设置税盘id
    setTaxId(value) {
        this.taxId = value
    },

    editPlateData(res){
        this.tax_disk_type = res.tax_disk_type
        this.invoiceTypes = res.invoice_types
        this.has_synced = res.has_synced
    },

    // 获取税盘列表
    getClientInvoiceType() {
        request({
            url: apis.getClientInvoiceType,
        }).then((res) => {
            this.getChecked(res)
            this.invoiceTypes = res;
        })
    },

    //选中开票发票类型
    getChecked(list){
        this.defaultCheckedInvoices = []
        list.forEach(item => {
            if (item.selected === 1) {
                this.defaultCheckedInvoices.push(item)
            }
        })
    },
    

    // 获取税盘列表
    getMachines(page, page_size = 10) {
        request({
            url: apis.getTaxManageList,
            method: "POST",
            data: {
                ...this.formData,
                page: page || this.manchineListPage,
                page_size
            }
        }).then((res) => {
            this.manchineList = res.list;
            this.manchineListPage = res.page
            this.manchineListTotal = +res.count
        })
    },

    createOrder(recordID, ext) {
        return request({ url: apis.createOrder, data: { id: recordID }})
    }
})

export default store;
